<div data-testid="failing-topics" class="topics-card">
  <div class="topics-card__header">
    <div class="topics-card__titles">
      <h4 class="topics-card__title">Top failing topics</h4>
      <p *ngIf="loaded" data-testid="failing-topics-subtitle" class="topics-card__subtitle">
        <ng-container *ngIf="riser; else plainSubtitle">Unresolved questions by topic. <span class="topics-bad">{{ riser.label }}</span> is up {{ riserChange }} on the previous {{ periodLong }}.</ng-container>
        <ng-template #plainSubtitle>Unresolved questions by topic, against the previous period.</ng-template>
      </p>
    </div>
  </div>
  <app-admin-dashboard-empty *ngIf="failed" data-testid="failing-topics-failed" icon="fa-regular fa-circle-exclamation" [title]="failedTitle"
                             body="Try again, or pick another period." [compact]="true"></app-admin-dashboard-empty>
  <app-admin-dashboard-empty *ngIf="loaded && !failed && !hasUnresolved" data-testid="failing-topics-empty" icon="fa-regular fa-list"
                             title="No unresolved questions in this view"></app-admin-dashboard-empty>
  <div *ngIf="loaded && hasUnresolved" #chart data-testid="failing-topics-chart" class="topics-card__chart"></div>
  <div *ngIf="!loaded" class="topics-card__chart"></div>
</div>
